import { MessageCircle } from "lucide-react";
import { buildWhatsAppLink } from "@/data/lakaData";

const WhatsAppFloat = () => {
  const wa = buildWhatsAppLink(
    "Hola LAKA CLUB BEAUTY, me gustaría reservar una cita.",
  );
  return (
    <a
      data-testid="floating-whatsapp-btn"
      href={wa}
      target="_blank"
      rel="noreferrer"
      aria-label="Abrir chat de WhatsApp"
      className="fixed bottom-6 right-6 md:bottom-8 md:right-8 z-40 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#D6B36A]/40 animate-ping" />
      <span className="relative flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#1A1A1A] text-[#FBF6F2] border border-[#D6B36A] shadow-[0_20px_40px_-15px_rgba(26,26,26,0.5)] transition-all duration-300 group-hover:bg-[#D6B36A] group-hover:text-[#1A1A1A]">
        <MessageCircle className="w-6 h-6" strokeWidth={1.5} />
      </span>
    </a>
  );
};

export default WhatsAppFloat;
